<template>
    <div>
        ZAGLUSHKA TEAM
    </div>
</template>

<script>
export default {
    name: "Team"
}
</script>

<style scoped>

</style>
